<template>
    <el-dialog v-dialogDrag class="viewDialog" width="1080px" :visible.sync="dialogVisible" v-loading="dialoading" :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                账单详细信息
            </div>
        </div>
        <div class="dialog_body">
            <el-tabs type="border-card" v-model="activeName">
                <el-tab-pane name="second">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i>  账单信息
                    </span>
                    <div style="padding: 20px 0">
                        <IntoBill :formData="form" v-if="flowInfo&&flowInfo.billType=='IntoBill'"></IntoBill>
                        <IntoRetBill :formData="form" v-if="flowInfo&&flowInfo.billType=='IntoRetBill'"></IntoRetBill>
                        <OutBill :formData="form" v-if="flowInfo&&flowInfo.billType=='OutBill'"></OutBill>
                        <OutRetBill :formData="form" v-if="flowInfo&&flowInfo.billType=='OutRetBill'"></OutRetBill>
                        <RequisitionBill :formData="form" v-if="flowInfo&&flowInfo.billType=='RequisitionBill'"></RequisitionBill>
                        <BorrowBill :formData="form" v-if="flowInfo&&flowInfo.billType=='BorrowBill'"></BorrowBill>
                        <BorrowRetBill :formData="form" v-if="flowInfo&&flowInfo.billType=='BorrowRetBill'"></BorrowRetBill>
                        <LendBill :formData="form" v-if="flowInfo&&flowInfo.billType=='LendBill'"></LendBill>
                        <LendRetBill :formData="form" v-if="flowInfo&&flowInfo.billType=='LendRetBill'"></LendRetBill>
                        <CheckBill :formData="form" v-if="flowInfo&&flowInfo.billType=='CheckBill'"></CheckBill>
                        <BreakageBill :formData="form" v-if="flowInfo&&flowInfo.billType=='BreakageBill'"></BreakageBill>
                        <TransferBill :formData="form" v-if="flowInfo&&flowInfo.billType=='TransferBill'"></TransferBill>

                        <PlanPurchase :formData="form" v-if="flowInfo&&flowInfo.billType=='PlanPurchase'"></PlanPurchase>
                        <PurchaseContract :formData="form" v-if="flowInfo&&flowInfo.billType=='PurchaseContract'"></PurchaseContract>
                        <SupplyOrder :formData="form" v-if="flowInfo&&flowInfo.billType=='SupplyOrder'"></SupplyOrder>
                        <SupplyInspect :formData="form" v-if="flowInfo&&flowInfo.billType=='SupplyInspect'"></SupplyInspect>
                        <SupplyReturn :formData="form" v-if="flowInfo&&flowInfo.billType=='SupplyReturn'"></SupplyReturn>
                        <SupplyInto :formData="form" v-if="flowInfo&&flowInfo.billType=='SupplyInto'"></SupplyInto>
                        <SupplyIntoRet :formData="form" v-if="flowInfo&&flowInfo.billType=='SupplyIntoRet'"></SupplyIntoRet>
                        <PurchaseInvoice :formData="form" v-if="flowInfo&&flowInfo.billType=='PurchaseInvoice'"></PurchaseInvoice>
                        <SporadicPurchase :formData="form" v-if="flowInfo&&flowInfo.billType=='SporadicPurchase'"></SporadicPurchase>

                        <SaleContract :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleContract'"></saleContract>
                        <SaleOrder :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleOrder'"></SaleOrder>
                        <SaleDelivery :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleDelivery'"></SaleDelivery>
                        <SaleReturn :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleReturn'"></SaleReturn>
                        <SaleInvoice :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleInvoice'"></SaleInvoice>
                        <SaleGift :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleGift'"></SaleGift>

                        <CollectionPlan :formData="form" v-if="flowInfo&&flowInfo.billType=='CollectionPlan'"></CollectionPlan>
                        <FeeBill :formData="form" v-if="flowInfo&&flowInfo.billType=='FeeBill'"></FeeBill>
                        <NonBusinessIn :formData="form" v-if="flowInfo&&flowInfo.billType=='NonBusinessIn'"></NonBusinessIn>
                        <NonBusinessPay :formData="form" v-if="flowInfo&&flowInfo.billType=='NonBusinessPay'"></NonBusinessPay>
                        <PurchasePay :formData="form" v-if="flowInfo&&flowInfo.billType=='PurchasePay'"></PurchasePay>
                        <SaleCollection :formData="form" v-if="flowInfo&&flowInfo.billType=='SaleCollection'"></SaleCollection>
                        <Voucher :formData="form" v-if="flowInfo&&flowInfo.billType=='Voucher'"></Voucher>

                        <Acceptance :formData="form" v-if="flowInfo&&flowInfo.billType=='Acceptance'"></Acceptance>
                        <ApplyFor :formData="form" v-if="flowInfo&&flowInfo.billType=='ApplyFor'"></ApplyFor>
                        <Dispatch :formData="form" v-if="flowInfo&&flowInfo.billType=='Dispatch'"></Dispatch>
                        <FollowUp :formData="form" v-if="flowInfo&&flowInfo.billType=='FollowUp'"></FollowUp>
                        <Handling :formData="form" v-if="flowInfo&&flowInfo.billType=='Handling'"></Handling>

                    </div>
                </el-tab-pane>
                <el-tab-pane name="third">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i>  附件信息
                    </span>
                    <div style="padding-top: 20px">
                        <fileupload :fileParam="fileParam" :fileListUrl="fileListUrl"></fileupload>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i>  审批过程
                    </span>

                    <div  style="padding-top: 20px">
                        <el-table
                                ref="table"
                                :data="dataList"
                                height="400"
                                style="width: 100%;"
                                highlight-current-row
                                row-key="id"
                                :header-cell-style="headerStyle"
                                :cell-style="cellStyle"
                                border>
                            <el-table-column
                                    type="index"
                                    label="步骤"
                                    width="50">
                            </el-table-column>
                            <el-table-column
                                    prop="ACT_NAME_"
                                    width="120"
                                    label="任务节点">
                            </el-table-column>
                            <el-table-column
                                    prop="ASSIGNEE_"
                                    width="100"
                                    label="办理人">
                            </el-table-column>
                            <el-table-column
                                    prop="START_TIME_"
                                    width="180"
                                    label="审批开始时间">
                            </el-table-column>
                            <el-table-column
                                    prop="END_TIME_"
                                    width="180"
                                    label="审批结束时间">
                            </el-table-column>
                            <el-table-column
                                    prop="ZTIME"
                                    width="120"
                                    label="用时">
                            </el-table-column>
                            <el-table-column
                                    prop="TEXT_"
                                    label="审批意见">
                            </el-table-column>
                        </el-table>
                    </div>

                </el-tab-pane>
                <el-tab-pane name="fiveth">
                    <span slot="label">
                        <i class="el-icon-paperclip"></i> 流程图
                    </span>
                    <div style="text-align: center">
                        <el-image :src="url" style="height:500px;" fit="contain"></el-image>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-dialog>
</template>

<script>
    //仓库管理
    import fileupload from '@/components/tools/fileupload/showList'

    import IntoBill from '@/components/page/stock/intobill/InfoPage'
    import IntoRetBill from '@/components/page/stock/intoretbill/InfoPage'
    import OutBill from '@/components/page/stock/outbill/InfoPage'
    import OutRetBill from '@/components/page/stock/outretbill/InfoPage'
    import RequisitionBill from '@/components/page/stock/requisitionbill/InfoPage'

    import BorrowBill from '@/components/page/stock/borrowbill/InfoPage'
    import BorrowRetBill from '@/components/page/stock/borrowretbill/InfoPage'
    import LendBill from '@/components/page/stock/lendbill/InfoPage'
    import LendRetBill from '@/components/page/stock/lendretbill/InfoPage'
    import CheckBill from '@/components/page/stock/checkbill/InfoPage'
    import BreakageBill from '@/components/page/stock/breakagebill/InfoPage'
    import TransferBill from '@/components/page/stock/transferbill/InfoPage'
    
    //采购管理
    import PlanPurchase from '@/components/page/purchase/planpurchase/InfoPage'
    import PurchaseContract from '@/components/page/purchase/purchasecontract/InfoPage'
    import SupplyOrder from '@/components/page/purchase/supplyorder/InfoPage'
    import SupplyInspect from '@/components/page/purchase/supplyinspect/InfoPage'
    import SupplyReturn from '@/components/page/purchase/supplyreturn/InfoPage'
    import SupplyIntoRet from '@/components/page/purchase/supplyintoret/InfoPage'
    import SupplyInto from '@/components/page/purchase/supplyinto/InfoPage'
    import PurchaseInvoice from '@/components/page/purchase/purchaseinvoice/InfoPage'
    import SporadicPurchase from '@/components/page/purchase/sporadicpurchase/InfoPage'

    //销售管理
    import SaleContract from "@/components/page/sale/salecontract/InfoPage";
    import SaleOrder from "@/components/page/sale/saleorder/InfoPage";
    import SaleDelivery from "@/components/page/sale/saledelivery/InfoPage";
    import SaleReturn from "@/components/page/sale/salereturn/InfoPage";
    import SaleInvoice from "@/components/page/sale/saleinvoice/InfoPage";
    import SaleGift from "@/components/page/sale/salegift/InfoPage";

    //财务管理
    import Voucher from '@/components/page/finance/voucher/InfoPage'
    import CollectionPlan from "@/components/page/finance/collectionplan/InfoPage";
    import FeeBill from "@/components/page/finance/feebill/InfoPage";
    import NonBusinessIn from "@/components/page/finance/nonbusinessin/InfoPage";
    import NonBusinessPay from "@/components/page/finance/nonbusinesspay/InfoPage";
    import PurchasePay from "@/components/page/finance/purchasepay/InfoPage";
    import SaleCollection from "@/components/page/finance/salecollection/InfoPage";

    //运维管理
    import Acceptance from '@/components/page/operations/acceptance/InfoPage'
    import ApplyFor from '@/components/page/operations/applyfor/InfoPage'
    import Dispatch from '@/components/page/operations/dispatch/InfoPage'
    import FollowUp from '@/components/page/operations/followup/InfoPage'
    import Handling from '@/components/page/operations/handling/InfoPage'

    export default {
        name: "editDialog",
        props: ['formData', 'spInfo','flowInfo', 'loading'],
        components: {
            CollectionPlan,
            SaleCollection,
            PurchasePay,
            NonBusinessIn,
            NonBusinessPay,
            FeeBill,
            Voucher,

            SaleContract,
            SaleOrder,
            SaleDelivery,
            SaleReturn,
            SaleInvoice,
            SaleGift,

            fileupload,
            IntoBill,
            IntoRetBill,
            OutBill,
            OutRetBill,
            RequisitionBill,
            BorrowBill,
            BorrowRetBill,
            LendBill,
            LendRetBill,
            CheckBill,
            BreakageBill,
            TransferBill,

            PlanPurchase,
            PurchaseContract,
            SupplyOrder,
            SupplyInspect,
            SupplyReturn,
            SupplyInto,
            SupplyIntoRet,
            PurchaseInvoice,
            SporadicPurchase,

            Acceptance,
            ApplyFor,
            Dispatch,
            FollowUp,
            Handling,


        },
        data() {
            return {
                activeName: "second",
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',

                dataList:[],
                url:require('@/assets/noData.jpg'),

                fileListUrl:"/billfile/getBillFile",
                fileParam:{
                    billId:this.spInfo.varBill.billId
                }
            };
        },

        mounted() {

            if(this.spInfo.hitaskList)
                this.dataList = this.spInfo.hitaskList;
            if(this.spInfo.pd)
                this.url = this.spInfo.pd.imgSrc;

            this.form = this.spInfo.varBill;
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            headerStyle() {
                return "text-align:center;height:35px;line-height:35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
        }
    }
</script>
